var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"footer"},[_c('div',{staticClass:"bj"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('button',{on:{"click":function($event){return _vm.goTop()}}},[_vm._v("免费体验")])])])}
var staticRenderFns = []

export { render, staticRenderFns }